import ProfilePage from '../Profile/ProfilePage'
import HeaderOuter from '../Nav Bar/HeaderOuter'
import LayoutShortcut from '../Layout Shortcut/Shortcut'


export default function Profileouter() {
  
  return (
   <>
   <HeaderOuter/>
   <ProfilePage/>
   <LayoutShortcut/>
   </>
  )
}
